import { useSettings } from "@/context/SettingsContext";
import { ShieldCheck } from "lucide-react";

export default function Terms() {
  const { settings } = useSettings();
  const holder = settings?.copyright_holder || settings?.site_name || "Drops of Honey";
  const year = new Date().getFullYear();

  return (
    <div className="max-w-3xl mx-auto px-4 lg:px-8 py-12">
      <div className="flex items-center gap-2 mb-2"><ShieldCheck className="w-6 h-6 brand-text" /><p className="font-tech text-xs uppercase tracking-widest brand-text">Legal</p></div>
      <h1 className="font-display text-4xl font-bold mb-6">Terms, Copyright & Ownership</h1>

      <div className="surface border rounded-2xl p-6 space-y-5 leading-relaxed">
        <section>
          <h2 className="font-display text-2xl font-bold mb-1">Ownership</h2>
          <p>This website, its name, brand, design, source code, database, and all original content are the exclusive property of <strong>{holder}</strong>. The platform is owned and operated solely by {holder}, who retains all rights, title, and interest in and to the application and its intellectual property.</p>
        </section>

        <section>
          <h2 className="font-display text-2xl font-bold mb-1">Copyright</h2>
          <p>© {year} {holder}. All rights reserved. No part of this site — including its layout, graphics, catalog data compilation, code, or branding — may be reproduced, distributed, or transmitted in any form without the prior written permission of {holder}, except for brief quotations in reviews or as permitted by copyright law.</p>
        </section>

        <section>
          <h2 className="font-display text-2xl font-bold mb-1">User Content</h2>
          <p>Collectors retain ownership of the photographs and text they upload. By posting content you grant {holder} a non-exclusive licence to display that content on this platform. You are responsible for ensuring you hold the rights to anything you upload.</p>
        </section>

        <section>
          <h2 className="font-display text-2xl font-bold mb-1">Advertising</h2>
          <p>Advertisements are reviewed and approved at the sole discretion of {holder}. Payment for an ad placement does not guarantee publication, and {holder} reserves the right to remove any advertisement at any time.</p>
        </section>

        <section>
          <h2 className="font-display text-2xl font-bold mb-1">Trademarks</h2>
          <p>“{settings?.site_name || "Drops of Honey"}” and its logo are trademarks of {holder}. Manufacturer names and marks referenced in the catalog (e.g., Hemingray, Brookfield) belong to their respective owners and are used for identification and educational purposes only.</p>
        </section>
      </div>

      <p className="text-center text-sm text-muted-page mt-6">© {year} {holder}. All rights reserved.</p>
    </div>
  );
}
